/*
 * Copyright (c) Worldline 2023.
 */

/**
 * End user web services
 * Endpoints of end user web services
 *
 * The version of the OpenAPI document: 2.2.3-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import {PersonalDataConsentVo} from './personalDataConsentVo';


/**
 * This Dto gives information about a signer.
 */
export interface SignerDto { 
    /**
     * External Signer Identifier.
     */
    extSignerId?: string;
    /**
     * Signer last name.
     */
    lastName?: string;
    /**
     * Signer fist name.
     */
    firstName?: string;
    /**
     * Signer gender.
     */
    gender?: SignerDto.GenderEnum;
    /**
     * Signer address.
     */
    address?: string;
    /**
     * Signer email.
     */
    email?: string;
    /**
     * Signer phone.
     */
    phone?: string;
    /**
     * Signer Type.
     */
    signerType?: SignerDto.SignerTypeEnum;
    signingMode?: SignerDto.SigningModeEnum;
    /**
     * External Signer Status.
     */
    externalSignerStatus?: SignerDto.ExternalSignerStatusEnum;
    globalPersonalDataConsent?: PersonalDataConsentVo;
}
export namespace SignerDto {
    export type GenderEnum = 'M' | 'F' | 'X';
    export const GenderEnum = {
        M: 'M' as GenderEnum,
        F: 'F' as GenderEnum,
        X: 'X' as GenderEnum
    };
    export type SignerTypeEnum = 'CUSTOMER' | 'PROSPECT';
    export const SignerTypeEnum = {
        Customer: 'CUSTOMER' as SignerTypeEnum,
        Prospect: 'PROSPECT' as SignerTypeEnum
    };
    export type SigningModeEnum = 'FACE_TO_FACE' | 'APPLICATION' | 'REMINDER';
    export const SigningModeEnum = {
        FaceToFace: 'FACE_TO_FACE' as SigningModeEnum,
        Application: 'APPLICATION' as SigningModeEnum,
        Reminder: 'REMINDER' as SigningModeEnum
    };
    export type ExternalSignerStatusEnum = 'EVIDENCES' | 'PENDING_EVIDENCE_VALIDATION' | 'EVIDENCES_KO' | 'PENDING_SIGNATURE' | 'AGREEMENTS' | 'AGREEMENTS_KO' | 'CERTIFICATE_APPROVAL' | 'CERTIFICATE_APPROVAL_KO' | 'SIGNATURES' | 'SIGNATURES_KO' | 'COMPLETED' | 'PENDING_CANCELLATION' | 'CANCEL';
    export const ExternalSignerStatusEnum = {
        Evidences: 'EVIDENCES' as ExternalSignerStatusEnum,
        PendingEvidenceValidation: 'PENDING_EVIDENCE_VALIDATION' as ExternalSignerStatusEnum,
        EvidencesKo: 'EVIDENCES_KO' as ExternalSignerStatusEnum,
        PendingSignature: 'PENDING_SIGNATURE' as ExternalSignerStatusEnum,
        Agreements: 'AGREEMENTS' as ExternalSignerStatusEnum,
        AgreementsKo: 'AGREEMENTS_KO' as ExternalSignerStatusEnum,
        CertificateApproval: 'CERTIFICATE_APPROVAL' as ExternalSignerStatusEnum,
        CertificateApprovalKo: 'CERTIFICATE_APPROVAL_KO' as ExternalSignerStatusEnum,
        Signatures: 'SIGNATURES' as ExternalSignerStatusEnum,
        SignaturesKo: 'SIGNATURES_KO' as ExternalSignerStatusEnum,
        Completed: 'COMPLETED' as ExternalSignerStatusEnum,
        PendingCancellation: 'PENDING_CANCELLATION' as ExternalSignerStatusEnum,
        Cancel: 'CANCEL' as ExternalSignerStatusEnum
    };
}


